// Visit https://api.openweathermap.org & then signup to get our API keys for free
module.exports = {
  key: "2d9b6dcb02f7d23d3f9edfaf97b11de9",
  base: "https://api.openweathermap.org/data/2.5/",
};
